import React from 'react';
import { Link } from 'react-router-dom';

export default function Summary({
    pool,
    i18n,
    links = true,
}) {
    const inputs = [
        {
            heading: i18n.dimensions.heading,
            url: `/${pool.id}/dimensions`,
            items: [
                [i18n.dimensions.surfaceArea, `${pool.surface_area}${i18n.dimensions.surfaceAreaHint}`],
                [i18n.dimensions.depth, `${pool.depth} ${i18n.dimensions.depthHint}`],
                [i18n.dimensions.type, pool.construction_type],
            ],
        },
        {
            heading: i18n.temperature.heading,
            url: `/${pool.id}/temperature`,
            items: [
                [i18n.temperature.requiredTemperature, `${pool.required_water_temperature}${i18n.temperature.requiredTemperatureHint}`],
                [i18n.temperature.usage, pool.pool_usage],
                [i18n.temperature.hoursUncovered, `${pool.hours_left_uncovered} ${i18n.temperature.hoursHint}`],
                [i18n.temperature.hoursUsed, `${pool.hours_used_a_day} ${i18n.temperature.hoursHint}`],
            ],
        },
        {
            heading: i18n.location.heading,
            url: `/${pool.id}/location`,
            items: [
                [i18n.location.country, pool.country],
                [i18n.location.city, pool.city],
            ],
        },
        {
            heading: i18n.seasons.heading,
            url: `/${pool.id}/seasons`,
            items: [
                [i18n.seasons.start, pool.season_start],
                [i18n.seasons.end, pool.season_end],
                [i18n.seasons.humidity, `${pool.humidity}%`],
                [i18n.seasons.air_temperature, `${pool.air_temperature}${i18n.temperature.requiredTemperatureHint}`],
            ],
        },
        {
            heading: i18n.power.heading,
            url: `/${pool.id}/power`,
            items: [
                [i18n.power.label, pool.power_supply],
                [i18n.power.spend, pool.power_spend],
            ],
        },
    ];

    const assumptions = [
        [i18n.advanced.pumpRunningHours, pool.pump_running_hours],
        [i18n.advanced.windSpeedInKph, pool.wind_speed],
        [i18n.advanced.waterCharacteristics, pool.water_characteristics],
        [i18n.advanced.waterTableHeight, pool.water_table_height],
        [i18n.advanced.waterPumpKw, pool.water_pump_kw],
        [i18n.advanced.numberOfPeople, pool.number_of_people],
    ];

    return <div className={`grid ${links ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-2'} gap-4 sm:gap-8`}>
        <div>
            <h3>{ i18n.summary.inputs }</h3>

            <div className="mt-4 space-y-6">
                { inputs.map(({ heading, url, items }) => {
                    return <div key={ heading }>
                        { links ? <Link to={ url } className="text-sm underline">
                            { heading }
                        </Link> : <h4 className="text-sm underline">
                            { heading }
                        </h4> }

                        <ul className="mt-2 space-y-0.5">
                            { items.map((item, index) => {
                                return <li key={`${index}`} className="text-sm">
                                    <span className="pr-1">{ item[0] }: &nbsp;</span>
                                    <span className="font-bold">{ item[1] }</span>
                                </li>
                            })}
                        </ul>

                    </div>
                })}
            </div>

        </div>
        <div>
            <h3>{ i18n.summary.assumptions }</h3>

            <ul className="mt-4 space-y-1">
                { assumptions.map((item, index) => {
                    return <li key={`${index}`} className="text-sm">
                        <span className="pr-1">{ item[0] }: &nbsp;</span>
                        <span className="font-bold">{ item[1] }</span>
                    </li>
                })}
            </ul>

            { links ? <div className="mt-4">
                <Link to={`/${pool.id}/advanced`} className="flex items-center space-x-3 text-sm text-grey-500 underline">
                    <span><svg width="15" height="15" xmlns="http://www.w3.org/2000/svg"><path d="M9.335 2.5L0 11.835V15h3.165L12.5 5.665 9.335 2.5zm2.82-2.5a.856.856 0 00-.597.247L10 1.806 13.193 5l1.558-1.559a.849.849 0 000-1.2L12.759.246A.839.839 0 0012.155 0zM9.25 5l.75.749-7.376 7.376h-.749v-.749L9.25 5z" fill="#000" fillRule="evenodd" opacity=".5"/></svg></span>
                    <span>{ i18n.summary.edit }</span>
                </Link>
            </div> : null }
        </div>
    </div>
}
